import React, { useState, useContext, useEffect } from 'react'
import styled from 'styled-components'
import { Table } from 'antd';
import { useRecoilState } from 'recoil';
import _ from 'lodash';
import { THEME } from "Util/constants";
import TableFilter from './TableFilter';
import PropTypes from "prop-types";
import { useLocation, Link } from 'react-router-dom'
import { vendorSearchAtom } from "Store/crmAtom";
import { LogisticsRouteContext } from '..';
import moment from 'moment';

const Container = styled.div`
	.ant-table-thead {
		.ant-table-cell {
			color: #999;
			font-weight: bold;
		}
	}

	.ant-table-tbody > tr:hover > td {
		background-color: "none";
	}
	.ant-table-tbody > tr.selected > td {
		background-color: ${THEME.colors.primary};
	}  
`;

const columns = [
    {
        title: 'Route Code',
        dataIndex: 'code',
        key: 'code',
        sorter: (a, b) => a.code?.localeCompare(b.code),
        sortDirections: ['ascend', 'descend', 'ascend'],
        width: '10%'
    },
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        sorter: (a, b) => a.date?.localeCompare(b.date),
        sortDirections: ['ascend', 'descend', 'ascend'],
        render: (time) => {
            const momentTime = moment(time).tz('Asia/Kolkata');
            return momentTime.tz('Asia/Kolkata').format('DD-MMM-YY')
        },
        width: '10%'
    },
    {
        title: 'Start Time',
        dataIndex: 'start_time',
        key: 'start_time',
        sorter: (a, b) => a.start_time?.localeCompare(b.start_time),
        sortDirections: ['ascend', 'descend', 'ascend'],
        render: (time) => {
            if (time){
                return moment(time).tz('Asia/Kolkata').format('hh:mmA')
            }
        },
        width: '10%'
    },
    {
        title: 'Driver',
        dataIndex: 'driver',
        key: 'driver',
        sorter: (a, b) => a.driver?.localeCompare(b.driver),
        sortDirections: ['ascend', 'descend', 'ascend'],
        width: '10%'
    },
    {
        title: 'Vehicle',
        dataIndex: 'vehicle',
        key: 'vehicle',
        sorter: (a, b) => a.vehicle?.localeCompare(b.vehicle),
        sortDirections: ['ascend', 'descend', 'ascend'],
        width: '10%'
    },
    {
        title: 'Depart From Address',
        dataIndex: 'depot_address',
        key: 'depot_address',
        sorter: (a, b) => a.depot_address?.localeCompare(b.depot_address),
        sortDirections: ['ascend', 'descend', 'ascend']
    },
    {
        title: 'End At Address',
        dataIndex: 'address',
        key: 'address',
        sorter: (a, b) => a.address?.localeCompare(b.address),
        sortDirections: ['ascend', 'descend', 'ascend']
    }
];


function DataTable({
    pageSize = 50,
    height = 250,
    data = [],
    loading = false
}) {
    const { selectedRecord, setSelectedRecord } = useContext(LogisticsRouteContext)
    const [search, setSearch ] = useRecoilState(vendorSearchAtom)
    const location = useLocation();

    const searchable = data.map((obj, i) => {
        let result = [];
        let concatenatedValues = "";
        columns.forEach(column => {
          if (obj[column.key] && obj[column.key] !== undefined) concatenatedValues += obj[column.dataIndex] + " ";
        });
        result.push(concatenatedValues.trim());
    
        return {
          ...obj,
          searchText:  result.toString()
        }
      })
    
    const filterData = (data) => {
        if(!search){
            return data
        }
        return _.filter(searchable, function (d) { 
            let query = search.toLowerCase();
            return _.includes(d.searchText.toLowerCase(), query)
        }); 
    };
    
    const handleRowClick = (row) => {
        setSelectedRecord(row);
    }
    
    useEffect(() => {
        setSelectedRecord({})
    }, [location.pathname, setSelectedRecord])

    useEffect(() => {
        return () => { setSearch('') }
    }, [setSearch])
    
    return (
        <Container>
            <TableFilter data={filterData(data)} column={columns}/>
            <Table
                loading={loading}
                columns={columns}
                dataSource={filterData(data)}
                onRow={(rec, idx) => ({
                    onClick: (e) => {
                      handleRowClick(rec)
                    }       
                })}
                pagination={{ defaultPageSize: pageSize }}
                scroll={{ y: height, x: 1500 }}
                rowKey={rec => parseInt(rec.id, 10)}
                components={{
                    body: {
                        row: (props) => {
                            const row = _.find(filterData(data), { id: props['data-row-key'] })
                            let selected = false;
                            if (!_.isEmpty(selectedRecord) && !_.isEmpty(row)) {
                                selected = row.id === selectedRecord.id;
                            }
                            const tableRow = (
                                <tr 
                                    {...props}
                                    style={{ cursor: 'pointer' }} 
                                    onClick={props.onClick}
                                    className={`ant-table-row ant-table-row-level-0 yeah ${selected ? "selected" : ""}`}
                                >
                                    {props.children}
                                </tr>
                            )

                            return tableRow
                        }
                    }
                }}
            />
        </Container>
    )

}

DataTable.propTypes = {
    pageSize: PropTypes.oneOf([10, 20, 50, 100]),
    height: PropTypes.number,
    data: PropTypes.arrayOf(PropTypes.object),
    loading: PropTypes.bool,
};

export default DataTable;